module.exports = __webpack_public_path__ + "google-play-badge-13f75d0c0b879ab370d3.png";